<template>
  <div class="ms-2" style="min-width: 45%;">
    <div class="score-container">
      <div class="d-flex flex-column">
        <div>
            <a href="#" data-toggle="modal" data-target="#profileModal" style="float: right;"
              @click.prevent="profileModal = true">
              <img src="/img/icons/ic_info.svg" alt="About Profile" class="ms-2"/>
            </a>
        </div>
        <div style="text-align: center;">
          <div> 
            <div class="image-container w-11">
            <img :src="imgPath" />
          </div>
          <div class="text-white text-capitalize pt-1" style="font-size: 0.85rem;">
              {{ name }}
          </div>
          <div class="px-2 text-nowrap"
              :class="`header-color-${confidence}`" style="font-size: 1.2rem;">
              {{ profileScore }}%
          </div>
        </div>
        </div>
      </div>

      <div id="scring-details" class="scring-details">
        <div id="dna-details" class="pt-2">
            <div class="score-label">DNA SCORE</div>
            <div class="d-flex flex-row">
              <icon-dna class="me-2 align-self-center" style="padding: 2px" />
              <argon-progress-with-alert
                style="width: 90%; padding-top: 2px"
                color="dna"
                :percentage="dnaScore"
                :end-text="dnaScore > 0 ? dnaScore + '%' : ''"
                :tooltip-text="
                  dnaScore <= 0
                    ? 'The profile score is reduced due to unavailability of DNA data. Schedule for a DNA test for more accurate profiling.'
                    : ''
                "/>
            </div>
        </div>
        <div id="wellness-details" class="pt-2">
            <div class="score-label">WELLNESS SCORE</div>
            <div class="d-flex flex-row">
              <icon-wellness class="me-2 align-self-center" style="padding: 1px" />
              <argon-progress-with-alert
                style="width: 90%; padding-top: 2px"
                color="wellness" :percentage="wellnessScore"
                :end-text="wellnessScore > 0 ? wellnessScore + '%' : ''"
                :tooltip-text="
                  wellnessScore <= 0
                    ? 'The profile score is reduced due to unavailability of wellness data. Fitness band needs to be worn for at least a month for more accurate profiling.'
                    : ''"
              />
            </div>
        </div>
      </div>
    </div>

    <!-- Profile Modal -->
    <modal
      id="profileModal"
      v-model:show="profileModal"
      class="modal fade"
      footer-classes="justify-content-end align-items-center"
      :show-close="true"
    >
      <template #header>
        <div class="header-container">
          <img
            src="/img/bg/bg-title.svg"
            alt="Background for header text"
            class="header-img"
          />
          <div class="header-text text-xl text-capitalize">{{ name }}</div>
        </div>
      </template>

      <div class="p-4">
        <user-profile-contributions
          :confidence="confidence"
          :dna-score="dnaScore"
          :wellness-score="wellnessScore"
          :genetic-contributions="geneticContributions"
          :profile-score="profileScore"
          :wellness-contributions="wellnessContributions"
          :display-dna="true"
        />
      </div>
      <template #footer>
        <button
          type="button"
          class="btn btn-primary"
          @click="profileModal = false"
        >
          OK
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import IconDna from "@/shared/Controls/Icons/IconDna.vue";
import IconWellness from "@/shared/Controls/Icons/IconWellness.vue";
import ArgonProgressWithAlert from "@/shared/Controls/ArgonProgressWithAlert.vue";
import Modal from "@/shared/Modal.vue";
import styles from "./UserReportItem.vue?vue&type=style&index=0&lang=scss&module=1";
import UserProfileContributions from "./profiler/UserProfileContributions.vue";

export default {
  name: "UserReportItem",
  components: {
    IconDna,
    IconWellness,
    Modal,
    UserProfileContributions,
    ArgonProgressWithAlert,
  },
  props: {
    name: {
      type: String,
      default: "Profile",
    },
    confidence: {
      type: String,
      default: "low",
    },
    dnaScore: {
      type: Number,
      default: 0,
    },
    wellnessScore: {
      type: Number,
      default: 0,
    },
    profileScore: {
      type: Number,
      default: 0,
    },
    geneticContributions: {
      type: Array,
      required: true,
    },
    wellnessContributions: {
      type: Array,
      required: true,
    },
    bgColor: {
      type: String,
      required: true,
    },
    imgPath: {
        type: String,
        default: "/img/pilot.jpg",
    },
  },
  data() {
    return {
      profileModal: false,
    };
  },
  mounted() {
    this.iconColor = styles.iconColor;
  },
  methods: {
    closeModal() {
      // console.log('Modal close triggered');
    },
  }
};
</script>
<style lang="scss" scoped>
.modal-footer {
  justify-content: space-between;
}
.bg {
  background-color: $g-gray-soft;
  border-radius: 0.25rem;
}
.title {
  font-weight: 600;
}
.subtitle {
  color: $color-secondary-text;
}
.header-container {
  position: relative;
  .header-img {
    position: absolute;
    left: -1.5rem;
    font-weight: bold;
  }
  .header-text {
    position: absolute;
    left: 1rem;
    top: 1rem;
  }
}

.image-container img {
	width: 4.5rem;
	height: 4.5rem;
	border-radius: 50%;
}
.score-container {
  background-color: #262E30;
  border-radius: 0.3rem;
  padding: 0.5rem;
  border: 1px solid #5e6f72;
}
.score-label {
  color: rgb(111, 123, 120);
  font-size: 0.75rem;
}

.scring-details {
  padding-left: 0.25rem;
}

:export {
  iconColor: $g-secondary_400;
}
</style>
